import React, { useMemo } from 'react';

// Material UI
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { MailOffIcon } from '../_core/_ui/icons.component';
import { isContactReachGap } from '../../lib/helpers/contact-reach.helpers';
import { useCompanySportTerminology } from '../../lib/stores/company.store';
import { getMessages } from './contact-reach.messages';

interface IContactReachAlertProps {
  contactReach?: ContactReach | null;
  // Only CONFIGURATION sees the Contacts section, so everyone else is told who can fix it.
  canEditContacts: boolean;
}

// The player page's answer to "why didn't this family get the report card / notice?".
export const ContactReachAlert: React.FC<IContactReachAlertProps> = ({ contactReach, canEditContacts }) => {
  const termLookup = useCompanySportTerminology();
  const messages = useMemo(() => getMessages(termLookup), [termLookup]);

  if (!isContactReachGap(contactReach)) return null;

  const hasNoContacts = contactReach === 'NO_CONTACTS';
  return (
    <Alert severity="error" variant="filled" icon={<MailOffIcon fontSize="inherit" />}>
      <AlertTitle>
        <IntlMsg {...(hasNoContacts ? messages.titleNoContacts : messages.titleUnreachable)} />
      </AlertTitle>
      <IntlMsg {...(hasNoContacts ? messages.bodyNoContacts : messages.bodyUnreachable)} />
      {' '}
      <IntlMsg {...(canEditContacts ? messages.actionEditContacts : messages.actionAskConfiguration)} />
    </Alert>
  );
};
